import React from 'react';
import PropTypes from 'prop-types';

// Used for copy headlines throughout website
const PageTextTitle = (props) => (
  <h2
    className={`${props.parentClass} title${
      props.class ? ` ${props.class}` : ''
    }`}
  >
    {props.text}
  </h2>
);

PageTextTitle.propTypes = {
  class: PropTypes.string,
  parentClass: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

PageTextTitle.defaultProps = {
  class: '',
};

export default PageTextTitle;
